import template from './estate-preview.pug';

export const EstatePreviewComponent = {
  template,
  bindings: {
    // Accept both 'estate' and 'record' for flexibility
    estate: '<',
    record: '<',
    isVisible: '<',
    onClose: '&',
    afterUpdate: '&?',
    onUpdate: '&?',
    afterNavigation: '&?',
    hotkeysEnabled: '<?',
    step: '<?'
  },
  controller: class EstatePreviewComponent {
    constructor(Estate, $async, $log) {
      'ngInject';
      this.Estate = Estate;
      this.$log = $log;
      this.navigateToRecord = $async(this.navigateToRecord.bind(this));
      this.load = $async(this.load.bind(this));
      this.hotkeysEnabled = true;
    }

    $onInit() {
      this.load();
    }

    $onChanges({estate}) {
      this.record = estate.currentValue;
    }

    load() {
      this.record = this.record || this.estate;
    }

    async navigateToRecord() {
      try {
        if (this.record && this.record.id) {
          await this.Estate.navigateToShow(this.record.id);
          if (this.afterNavigation) this.afterNavigation({ $event: {} });
          this.close();
        }
      } catch (e) {
        this.$log.error(e);
      }
    }

    close() {
      if (this.onClose) this.onClose({ $event: {} });
    }
  }
};
